import {
	Component,
	forwardRef,
	EventEmitter,
	Output,
	Input,
} from '@angular/core';
import { touchControl } from 'src/shared/utilities/utility-functions';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import {
	ControlValueAccessor,
	FormControl,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as moment from 'moment';
import { MatSelectChange } from '@angular/material/select';

@Component({
	selector: 'rpshared-select-list',
	templateUrl: './select-list.component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => RpSelectListComponent),
			multi: true,
		},
	],
})
export class RpSelectListComponent
	extends SelfDestruct
	implements ControlValueAccessor
{
	private _required = false;
	@Input()
	get required(): boolean {
		return this._required;
	}
	set required(value: boolean) {
		this._required = coerceBooleanProperty(value);
	}
	@Input() placeholder: string;
	@Input() items: any[];
	@Input() unit: string;
	@Input() displayFunc?: (input: string) => string = undefined;
	@Output() selectionChange = new EventEmitter<MatSelectChange>();

	selectListControl = new FormControl('') as FormControl;

	constructor() {
		super();
	}

	// model --> view
	writeValue(value: string): void {
		if (value) {
			this.selectListControl.setValue(value, { emitEvent: false });
		} else {
			this.selectListControl.reset('');
		}
	}

	// view --> model
	registerOnChange(fn: (value: string | moment.Moment) => void) {
		this.selectListControl.valueChanges
			.pipe(takeUntil(this.destroyed))
			.subscribe(fn);
	}

	registerOnTouched(fn: () => void) {
		this.onTouched = touchControl(this.selectListControl)(fn);
	}

	onTouched: () => void = () => {};
}
